import axios from 'axios';

export const getLoginMessage = async (): Promise<string> =>{
    try {
        const response = await axios.get(`/api/LoginMessage/loadLoginMessage`);        
        return response.data;
    } catch (error) {
        console.error('Error fetching login message:', error);
        throw error;
    }
}
